'use client';
import Script from 'next/script';

export default function GoogleGsiScript() {
  return <Script src="https://accounts.google.com/gsi/client" async defer />;
}
